import {useState, useRef, useEffect} from 'react';

interface NewReferentialProps{
    createReferent: (cName: string) => void;
    selectReferent: (index?: number) => void;
}

export function UntitledReferent(props: NewReferentialProps) {

    const [text, setText] = useState<string>("Untitled");
    const inputElement = useRef<HTMLInputElement>(null);

    useEffect(() => {
        inputElement.current?.select();
    }, [])

    const onChangeHandler = (e: any) => {
        setText(e.target.value)
    }
    const onKeyDownHandler = (e: React.KeyboardEvent<HTMLInputElement>) => {
        e.stopPropagation()
        if(e.key === "Enter" && text !== "" && text !== ""){
            e.preventDefault()
            props.createReferent(text)
        }else if(e.key === 'ArrowUp' || e.key === 'Escape'){
            props.selectReferent(-1)
        }else if(e.key === 'ArrowDown'){
            props.selectReferent(0)
        }
    }
    return (
        <input 
         autoFocus
         ref={inputElement}
         onBlur={(e) => {
            const relatedTarget = e.relatedTarget as HTMLElement
            if(!relatedTarget || !relatedTarget.classList.contains("referent")){
                props.selectReferent()
            }
         }}
         className="new-entity"
         key="new-entity"
         value={text} 
         onChange={(e) => onChangeHandler(e)}
         onKeyDown={onKeyDownHandler}
         placeholder="Add canonical name"
        />
    )
}